import { KDatePicker, KForm, KTimePicker } from "kinnect-general";
import { formatDate } from "kinnect-formatters";
import { isSunday, parseISO } from "date-fns";
import {
	VCheckbox,
	VCol,
	VRow
} from "vuetify/lib";

export default KForm.extend( {
	name: "KDriverTimeOffForm",

	props: {
		idDriver: Number,
		timeOff: Object
	},

	data: () => ( {
		formFields: {
			allDay: false,
			startDate: null,
			startTime: null,
			endDate: null,
			endTime: null
		},
		today: ( new Date() ).setHours( 0, 0, 0, 0 )
	} ),

	computed: {
		editing() {
			return Boolean( this.timeOff );
		},

		formUrl() {
			return this.editing
				? `yard/drivers/${this.idDriver}/time-off/${this.timeOff.id}`
				: `yard/drivers/${this.idDriver}/time-off`;
		},

		todayFormatted() {
			return formatDate( this.today, "yyyy-MM-dd" );
		},

		internalRedirect() {
			if ( this.redirect ) {
				return this.redirect;
			}

			return [ "back", {
				name: "yardDriver",
				params: { idDriver: this.idDriver }
			} ];
		}
	},

	watch: {
		timeOff: {
			handler( timeOff ) {
				if ( timeOff ) {
					Object.keys( this.formFields ).forEach( key => {
						if ( timeOff.hasOwnProperty( key ) ) {
							this.formFields[key] = timeOff[key];
						}
					} );
				}
			},
			immediate: true
		},

		"formFields.allDay"( val ) {
			if ( val ) {
				this.formFields.startTime = null;
				this.formFields.endTime = null;
			}
		}
	},

	methods: {
		isDateAllowed( date ) {
			return !isSunday( parseISO( date ) );
		}
	},

	render() {
		return <KForm
			attrs={{
				...this.$props,
				action: this.formUrl,
				data: this.formFields,
				method: this.editing ? "put" : "post",
				redirect: this.internalRedirect
			}}
			on={this.$listeners}
		>
			<VCheckbox
				color="accent"
				hideDetails
				label="All Day"
				vModel={this.formFields.allDay}
			></VCheckbox>

			<VRow>
				<VCol class="pb-0" cols={12} sm={6}>
					<KDatePicker
						datePickerProps={{
							allowedDates: this.isDateAllowed,
							min: this.todayFormatted
						}}
						textFieldProps={{
							label: "Start Date*",
							required: true,
							validationName: "start date",
							validationRules: "required"
						}}
						vModel={this.formFields.startDate}
					></KDatePicker>
				</VCol>

				<VCol class="pb-0" cols={12} sm={6}>
					<KTimePicker
						disabled={this.formFields.allDay}
						textFieldProps={{
							label: "Start Time*",
							placeholder: this.formFields.allDay ? "All Day" : null,
							required: true,
							validationName: "start time",
							validationRules: { required: !this.formFields.allDay }
						}}
						vModel={this.formFields.startTime}
					></KTimePicker>
				</VCol>
			</VRow>

			<VRow>
				<VCol class="pb-0" cols={12} sm={6}>
					<KDatePicker
						datePickerProps={{
							allowedDates: this.isDateAllowed,
							min: this.formFields.startDate
								? this.formFields.startDate
								: this.todayFormatted
						}}
						textFieldProps={{
							label: "End Date*",
							required: true,
							validationName: "end date",
							validationRules: "required"
						}}
						vModel={this.formFields.endDate}
					></KDatePicker>
				</VCol>

				<VCol class="pb-0" cols={12} sm={6}>
					<KTimePicker
						disabled={this.formFields.allDay}
						textFieldProps={{
							label: "End Time*",
							placeholder: this.formFields.allDay ? "All Day" : null,
							required: true,
							validationName: "end time",
							validationRules: { required: !this.formFields.allDay }
						}}
						vModel={this.formFields.endTime}
					></KTimePicker>
				</VCol>
			</VRow>
		</KForm>;
	}
} );
